import { withHomeAgendaSearch } from "@dust-tt/front/components/home/homeAgendaQuery";
import { HomeRouterLayout } from "@spa/app/layouts/HomeRouterLayout";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";

function CalendarToHomeRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={`../home${withHomeAgendaSearch(location.search, true)}${location.hash}`}
      replace
    />
  );
}

export const calendarRoutes: RouteObject[] = [
  {
    element: <HomeRouterLayout />,
    children: [{ path: "calendar", element: <CalendarToHomeRedirect /> }],
  },
];
